import React from "react";
import {Tabs} from "antd";
import Pie from "./pie.js";
import HeatMap from "./heatmap.js"
import ScatterPlotClustered from "./scatterPlotClustered.js"
import Scatter3D from "./scatter3d.js";
import SummaryTable from "./summaryTable";

import {BorderOuterOutlined, DotChartOutlined, HeatMapOutlined, PieChartOutlined, TableOutlined} from '@ant-design/icons';

export default function Multichart({mainData, firstRowDivHeight, results, pdb, onNestedRowClick, folder, sortOnClick, sortInteractionTypeOnClick}) {
    return (
        <>
            <Tabs
                tabPosition="top"
                centered
                items={[
                    {
                        key: '1',
                        label: <TableOutlined className="multichart-icon"/>,
                        children: <SummaryTable mainData={mainData} results={results}
                                                firstRowDivHeight={firstRowDivHeight} pdb={pdb} onNestedRowClick={onNestedRowClick}></SummaryTable>,
                    },
                    {
                        key: '2',
                        label: <PieChartOutlined className="multichart-icon"/>,
                        children: <Pie mainData={mainData} results={results}
                                       firstRowDivHeight={firstRowDivHeight} onNestedRowClick={onNestedRowClick} sortInteractionTypeOnClick={sortInteractionTypeOnClick}></Pie>,
                    },
                    {
                        key: '3',
                        label: <HeatMapOutlined className="multichart-icon"/>,
                        children: <HeatMap mainData={mainData} results={results} firstRowDivHeight={firstRowDivHeight}
                                           onNestedRowClick={onNestedRowClick} pdb={pdb} folder={folder} sortOnClick={sortOnClick}></HeatMap>,
                    },
                    {
                        key: '4',
                        label: <DotChartOutlined className="multichart-icon"/>,
                        children: <ScatterPlotClustered mainData={mainData} results={results} firstRowDivHeight={firstRowDivHeight}
                                                        onNestedRowClick={onNestedRowClick} pdb={pdb} folder={folder} sortOnClick={sortOnClick}></ScatterPlotClustered>,
                    },
                    {
                        key: '5',
                        label: <BorderOuterOutlined className="multichart-icon"/>,
                        children: <Scatter3D mainData={mainData} results={results} firstRowDivHeight={firstRowDivHeight}
                                             onNestedRowClick={onNestedRowClick} pdb={pdb} folder={folder} sortOnClick={sortOnClick}></Scatter3D>
                    }/*,
                    {
                        key: '5',
                        label: <BorderOuterOutlined className="multichart-icon" />,
                        children: <ChatGPTTableExplorer mainData={mainData} firstRowDivHeight={firstRowDivHeight}></ChatGPTTableExplorer>
                    }*/
                ]}
            />
        </>
    )
}